import { Skeleton } from './Skeleton';

/**
 * Skeleton for individual story card.
 * Matches the layout of StoryBox component.
 */
export const StoryBoxSkeleton = ({ index = 0 }: { index?: number }) => {
  const bgColor = index % 2 === 0 ? 'bg-canvas' : 'bg-surface';

  return (
    <div className={`${bgColor} py-12`}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Date and place */}
        <div className="flex justify-center items-center mb-4 space-x-2">
          <Skeleton className="h-5 w-32" />
          <span className="text-muted">&bull;</span>
          <Skeleton className="h-5 w-24" />
        </div>

        {/* Title */}
        <div className="flex justify-center">
          <Skeleton className="h-10 w-64" />
        </div>

        {/* Description */}
        <div className="mt-4 max-w-2xl mx-auto space-y-2">
          <Skeleton className="h-6 w-full" />
          <Skeleton className="h-6 w-5/6" />
          <Skeleton className="h-6 w-4/6" />
        </div>

        {/* Images */}
        <div className="mt-6 flex flex-wrap gap-1 justify-center">
          {[1, 2, 3].map((i) => (
            <Skeleton key={i} className="h-[200px] w-[200px] rounded-xl" />
          ))}
        </div>

        {/* Comment section placeholder */}
        <div className="mt-6 max-w-3xl mx-auto px-4 sm:px-0">
          <div className="flex gap-4">
            <Skeleton className="h-10 w-24 rounded-full" />
            <Skeleton className="h-10 w-32 rounded-full" />
          </div>
        </div>
      </div>
    </div>
  );
};
